/**
 * BftAttachmentsButton - iter1086h (Phase C follow-up)
 *
 * Thin wrapper around the unified `AttachDocsButton` so every bank
 * feed row (Review Needed, Uncategorised, Completed, Transaction
 * Table) uses the SAME upload/list/detach flow as invoices, bills,
 * journals, fixed assets, loans, investments, etc.
 *
 * Migrated from the legacy `POST /api/bank-feeds/{bftId}/attachments`
 * (which wrote directly into `bank_feed_transactions.attachments[]`)
 * to the unified `POST /api/documents/upload` + `links[]` backbone,
 * so a bank-feed receipt attached here now cross-links to the matched
 * invoice/bill automatically (see routers/docs_sync.py Phase B).
 *
 * Any legacy `attachments[]` records still on the transaction row are
 * surfaced by the backend's dual-read fallback in
 * `_list_docs_for_entity()` so no user data disappears during rollout.
 */
import React from 'react';
import AttachDocsButton from '../documents/AttachDocsButton';

export function BftAttachmentsButton({ bftId, compact = false, className = '' }) {
  if (!bftId) return null;
  return (
    <AttachDocsButton
      entityType="bank_feed_txn"
      entityId={bftId}
      uploadedVia="bank_feed"
      variant={compact ? 'icon' : 'chip'}
      className={className}
    />
  );
}

export default BftAttachmentsButton;
